import React from 'react';

const ChevronRightIcon = () => (
  <svg
    fill="currentColor"
    // fill="white"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6" // สามารถปรับขนาดได้จาก class นี้
  >
    <path
      fillRule="evenodd"
      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default ChevronRightIcon;
